import { getEnvironment } from '../../../utils/envHelpers'
import styles from './EnvBar.module.scss'

const EnvBar = () => {
  const env = getEnvironment()

  if (env !== 'prod') {
    return (
      <>
        <div className={styles.bar}></div>
      </>
    )
  }

  return null
}

export default EnvBar
